import React from 'react';
import { Link } from 'react-router-dom';
import { personPhoto } from '../../data/images';
import { useCollections } from '../../lib/api/collections';

const shorten = (text, max) => (text.length > max ? `${text.slice(0, text.lastIndexOf(' ', max))}...` : text);

const Message = ({ label, person, link }) => (
  <div className="col-xl-6 col-lg-6 mb-30">
    <div className="sc-message">
      <img src={personPhoto(person)} alt="" loading="lazy" />
      <div>
        <small>{label}</small>
        <h4>{person.name}</h4>
        {person.title && <span>{person.title}</span>}
        {shorten(person.message, 520).split(/\n\s*\n/).map((p) => <p key={p}>{p}</p>)}
        {link && <Link to={link}>Read the full message &rarr;</Link>}
      </div>
    </div>
  </div>
);

// Shown on the home page once a Vice-Chancellor's message is published in the back office. The Chairman's message sits beside it.
const MessagesSection = () => {
  const { messages } = useCollections('messages');
  if (!messages || !messages.viceChancellor) return null;
  return (
    <div className="sc-messages pt-100 pb-70">
      <div className="container">
        <div className="row">
          {messages.chairman && <Message label="Message from the Chairman" person={messages.chairman} link="/chairman" />}
          <Message label="Message from the Vice-Chancellor" person={messages.viceChancellor} />
        </div>
      </div>
    </div>
  );
};

export default MessagesSection;
